import { useEffect, useState } from 'react';
import { ReactComponent as CrownSvg } from '../../../assets/svg/crown.svg';
import request from '../../../lib/request';

const ChallengeList = ({ list, handleClickChallenge }) => {
  return (
    <div className='flex flex-col gap-4'>
      {list.map((item) => (
        <div
          key={item.id}
          className='flex items-center gap-4'
          onClick={handleClickChallenge(item.id)}
        >
          <div className='relative aspect-[2/3] w-[50vw] rounded-md overflow-hidden min-w-[108px] max-w-[144px]'>
            <img
              src={item.bannerUrl}
              alt={item.title}
              className='w-full h-full object-cover'
            />
            {item.premium && (
              <div className='absolute top-0 left-0 bg-accent px-2 py-[2px] rounded-tl-md rounded-br-md'>
                <CrownSvg className='size-3' />
              </div>
            )}
          </div>
          <div className='flex flex-col gap-2'>
            <h1 className='text-sm font-bold'>{item.title}</h1>
            <p className='text-xs line-clamp-3'>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

const PackPopup = ({
  dialogRef,
  closeDialog,
  handleClickChallenge,
  selectedPackId,
  packPopupOpen,
}) => {
  const [challenges, setChallenges] = useState([]);
  const [pack, setPack] = useState(null);

  useEffect(() => {
    if (packPopupOpen) {
      getPack();
    }
  }, [packPopupOpen]);

  const getPack = async () => {
    try {
      const { result } = await request.get(`/challenge/pack/${selectedPackId}`);
      if (result) {
        setPack(result);
        const list = [];
        result.challenges.forEach((item) => {
          if (item.premium) {
            list.push(item);
          } else {
            list.unshift(item);
          }
        });
        setChallenges(list);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-secondary text-white scrollbar-hidden'
    >
      {pack && (
        <div className='pb-8'>
          <div className='p-4'>
            <div className='relative'>
              <img
                src={pack.bannerUrl}
                alt='challenge poster'
                className='w-full rounded-xl'
              />
              <button
                className='text-2xl absolute top-2 right-2 size-6 bg-tertiary/70 rounded-full flex items-center justify-center '
                onClick={closeDialog}
              >
                🅧
              </button>
            </div>
            <h1 className='text-center mt-4 text-lg font-bold'>{pack.title}</h1>
            <p className='mt-4 mb-6 whitespace-pre-line text-sm'>
              {pack.description}
            </p>
          </div>
          <div className='w-full border-t-4 border-black mb-2' />
          <div className='p-4'>
            <ChallengeList
              list={challenges}
              handleClickChallenge={handleClickChallenge}
            />
          </div>
        </div>
      )}
    </dialog>
  );
};

export default PackPopup;
